import { SectorModel } from './../../service/sector.model';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PredictService } from './../../service/predict.service';
import { DBConnectorService } from './../../service/test.service';
import { Component, OnInit } from '@angular/core';
// import { DialogService } from 'ng2-bootstrap-modal';
import { ShowLogDialogComponent } from '../../show-log-dialog/show-log-dialog.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-predict-using-excel',
  templateUrl: './predict-using-excel.component.html',
  styleUrls: ['./predict-using-excel.component.css']
})
export class PredictUsingExcelComponent implements OnInit {

  predictDesc: string;
  bsModalRef: BsModalRef;
  sectormodel = new SectorModel;
  enableGetLogs: boolean;
  Description = {
    "Sector": null,
    "Model": null,
    "Desc": "",
    "User":"" //chandra

  };
  result:any = { "Status": null };
  Instaresult:any = {};

  constructor(private sectorservice: DBConnectorService,
    private predictservice: PredictService,
    private http: HttpClient,
    private router: Router,
    private _dialogService: BsModalService
    ) {

    this.sectormodel.SectorName = this.sectorservice.SectorName;
    this.sectormodel.ModelName = this.sectorservice.ModelName;
    this.sectormodel.User = this.sectorservice.username;
  }
 

  onInstant() {
    this.enableGetLogs = true
    this.Description.Sector = this.sectorservice.SectorName;
    this.Description.Model = this.sectorservice.ModelName;
    this.Description.User = this.sectorservice.username; 
    this.Description.Desc = this.predictDesc;

    console.log("Instant Predict - start");
    console.log(this.Description);
    this.predictservice.Insta(this.Description)
      .subscribe(
      (data) => {
        this.Instaresult = data;
        this.predictservice.setInsta(this.Instaresult);
        console.log(this.Instaresult);
        console.log("Instant predict - after api");
        this.router.navigate(['Predict/InstantPredict']);
      },
      (error) => console.log(error));
    //this.router.navigate(['Predict/InstantPredict']);

  }
  
  DownloadPredict() {
    // alert("file download");

    // let headers = new Headers({ 'Content-Type': 'application/json' });
    let options: object = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      responseType: 'blob',
      observe: 'response'
    }

    let url = "/api/Download/DownloadPredict" + "?Sector=" + this.sectorservice.SectorName + "&Model=" + this.sectorservice.ModelName + "&User=" + this.sectorservice.username;
    this.http.post<any>(url, '', options)
      .subscribe((res) => {

        let parsedResponse = res.body;
        var contentType = 'application/octet-stream';
        let blob = new Blob([parsedResponse], { type: contentType });
        let url = window.URL.createObjectURL(blob);
        // window.open(url);
        let contentDispositionHeader = res.headers.get("content-disposition");
        let filename = contentDispositionHeader.split('=')[1].trim();

        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);


      }
    );
  }
  
  ngOnInit() {
  }

  OpenLogsDialog() {
    console.log("clicked!")
    const initialState = {
      source: "predict",
      username: this.sectorservice.username
    };
    this.bsModalRef = this._dialogService.show(ShowLogDialogComponent, { initialState })
    //this._dialogService.addDialog(ShowLogDialogComponent, { source: "predict", username: this.sectorservice.username }).subscribe(data => console.log(data))
  }

  OpenexcelLogsDialog() {
    console.log("excel logs clicked!")
    const initialState = {
      source: "excel_predict",
      username: this.sectorservice.username
    };
    this.bsModalRef = this._dialogService.show(ShowLogDialogComponent, { initialState })
    //this._dialogService.addDialog(ShowLogDialogComponent, { source: "excel_predict", username: this.sectorservice.username }).subscribe(data => console.log(data))
  }

}
